export const defaultValues = {
  password: '',
  repeatPassword: '',
};
